<script>
  import { langId } from "../js/stores.js"

  import { addMessages, locale } from "svelte-i18n"

  import en from "../lang/en.json"
  import el from "../lang/el.json"

  addMessages("en", en)
  addMessages("el", el)

  // Custom remember and switch lang code
  if (localStorage.getItem("lang")) {
    $langId = localStorage.getItem("lang")
  } else {
    navigator.language.slice(0, 2) === "el"
      ? ($langId = "el")
      : ($langId = "en")
    // Since only el and en are supported we sould fall back to en if another lang is detected
  }
  // End Custom

  $: locale.set($langId) // from "svelte-i18n"
</script>
